import { Box, Button, Container, Typography } from '@mui/material'
import { useNavigate, useRouteError } from 'react-router-dom'

export default function ErrorPage() {
  const error = useRouteError() as any
  const navigate = useNavigate()

  return (
    <Container maxWidth='sm'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
          textAlign: 'center'
        }}
      >
        <Typography variant='h3' color='error'>
          Oops!
        </Typography>
        <Typography variant='h5'>Sorry, an unexpected error has occurred.</Typography>
        <Typography variant='body1' color='text.secondary'>
          {error?.statusText || error?.message || 'Unknown error'}
        </Typography>
        <Button variant='contained' onClick={() => navigate('/')}>
          Go Home
        </Button>
      </Box>
    </Container>
  )
}
